import React from 'react';
import { FaSearch, FaBarcode, FaBox, FaPlus, FaTrash } from 'react-icons/fa';

const ProductsTable = ({
  products,
  units,
  productSearchIndex,
  setProductSearchIndex,
  productSearchQuery,
  setProductSearchQuery,
  productSearchResults,
  showProductResults,
  searchingProducts,
  productSearchRef,
  saveNewProducts,
  setSaveNewProducts,
  handleSelectProduct,
  addProduct,
  updateProduct,
  removeProduct,
  calculateTotal,
  cardStyle,
  cardHeaderStyle,
  inputStyle,
  btnStyle
}) => {
  const defaultUnits = [
    { id: 1, skrot: 'szt' }, { id: 2, skrot: 'kg' }, { id: 3, skrot: 'l' },
    { id: 4, skrot: 'm' }, { id: 5, skrot: 'op' }, { id: 6, skrot: 'usl' }
  ];

  return (
    <div style={cardStyle}>
      <div style={cardHeaderStyle}>
        <FaBox /> Pozycje faktury
        <label style={{ marginLeft: '1rem', fontSize: '10px', display: 'flex', alignItems: 'center', gap: '4px', fontWeight: 'normal' }}>
          <input
            type="checkbox"
            checked={saveNewProducts}
            onChange={(e) => setSaveNewProducts(e.target.checked)}
            style={{ width: '14px', height: '14px' }}
          />
          Zapisuj nowe produkty do bazy
        </label>
        <button
          onClick={addProduct}
          style={{ ...btnStyle, marginLeft: 'auto', border: '1px solid var(--info)', color: 'var(--info)' }}
        >
          <FaPlus /> Dodaj pozycje
        </button>
      </div>
      <div style={{ padding: '0.75rem' }}>
        {products.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)', fontSize: '12px' }}>
            Brak pozycji. Kliknij "Dodaj pozycje" aby dodac produkty do faktury.
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px' }}>
            <thead>
              <tr style={{ backgroundColor: 'var(--bg)' }}>
                <th style={{ padding: '0.5rem', textAlign: 'left', borderBottom: '1px solid var(--border)', width: '30px' }}>Lp.</th>
                <th style={{ padding: '0.5rem', textAlign: 'left', borderBottom: '1px solid var(--border)' }}>Nazwa / EAN</th>
                <th style={{ padding: '0.5rem', textAlign: 'center', borderBottom: '1px solid var(--border)', width: '70px' }}>Ilosc</th>
                <th style={{ padding: '0.5rem', textAlign: 'center', borderBottom: '1px solid var(--border)', width: '65px' }}>J.m.</th>
                <th style={{ padding: '0.5rem', textAlign: 'right', borderBottom: '1px solid var(--border)', width: '80px' }}>Netto</th>
                <th style={{ padding: '0.5rem', textAlign: 'center', borderBottom: '1px solid var(--border)', width: '60px' }}>VAT</th>
                <th style={{ padding: '0.5rem', textAlign: 'right', borderBottom: '1px solid var(--border)', width: '80px' }}>Brutto</th>
                <th style={{ padding: '0.5rem', textAlign: 'right', borderBottom: '1px solid var(--border)', width: '80px' }}>Wartosc</th>
                <th style={{ padding: '0.5rem', textAlign: 'center', borderBottom: '1px solid var(--border)', width: '35px' }}></th>
              </tr>
            </thead>
            <tbody>
              {products.map((product, index) => (
                <tr key={product.id || index} style={{ backgroundColor: product.isFromDb ? 'var(--success-light)' : 'transparent' }}>
                  <td style={{ padding: '0.35rem', borderBottom: '1px solid var(--bg)', verticalAlign: 'top' }}>
                    {index + 1}
                    {product.isFromDb && <FaBox style={{ color: 'var(--success)', marginLeft: '2px', fontSize: '9px' }} title="Z bazy" />}
                  </td>
                  <td
                    style={{ padding: '0.35rem', borderBottom: '1px solid var(--bg)', position: 'relative' }}
                    ref={productSearchIndex === index ? productSearchRef : null}
                  >
                    <div style={{ position: 'relative', marginBottom: '4px' }}>
                      <FaSearch style={{
                        position: 'absolute', left: '6px', top: '50%',
                        transform: 'translateY(-50%)', color: 'var(--text-muted)', fontSize: '10px'
                      }} />
                      <input
                        type="text"
                        value={productSearchIndex === index ? productSearchQuery : ''}
                        onChange={(e) => { setProductSearchIndex(index); setProductSearchQuery(e.target.value); }}
                        onFocus={() => { setProductSearchIndex(index); if (productSearchQuery.length >= 2) { /* show results */ } }}
                        style={{ ...inputStyle, padding: '0.25rem 0.35rem 0.25rem 22px', fontSize: '10px' }}
                        placeholder="Szukaj po nazwie lub EAN..."
                      />
                      {productSearchIndex === index && showProductResults && productSearchResults.length > 0 && (
                        <div style={{
                          position: 'absolute', top: '100%', left: 0, right: 0,
                          backgroundColor: 'var(--card-bg)', border: '1px solid var(--border)',
                          borderRadius: '4px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                          zIndex: 200, maxHeight: '180px', overflowY: 'auto'
                        }}>
                          {productSearchResults.map(p => (
                            <div
                              key={p.id}
                              onClick={() => handleSelectProduct(p, index)}
                              style={{ padding: '0.4rem 0.5rem', cursor: 'pointer', borderBottom: '1px solid var(--bg)', fontSize: '10px' }}
                              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'var(--bg)'}
                              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'var(--card-bg)'}
                            >
                              <div style={{ fontWeight: '600' }}>{p.nazwa || p.name}</div>
                              <div style={{ color: 'var(--text-muted)', fontSize: '9px' }}>
                                {(p.ean || p.kod_kreskowy) && <><FaBarcode style={{ marginRight: '3px' }} />{p.ean || p.kod_kreskowy} | </>}
                                Cena: {parseFloat(p.cena_sprzedazy_brutto || 0).toFixed(2)} zl
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                      {productSearchIndex === index && searchingProducts && (
                        <div style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', fontSize: '10px', color: 'var(--text-muted)' }}>...</div>
                      )}
                    </div>
                    <input
                      type="text"
                      value={product.nazwa}
                      onChange={(e) => { updateProduct(index, 'nazwa', e.target.value); updateProduct(index, 'isFromDb', false); }}
                      style={{ ...inputStyle, padding: '0.25rem 0.35rem' }}
                      placeholder="Nazwa produktu..."
                    />
                    <input
                      type="text"
                      value={product.ean || ''}
                      onChange={(e) => updateProduct(index, 'ean', e.target.value)}
                      style={{ ...inputStyle, padding: '0.2rem 0.35rem', marginTop: '3px', fontSize: '10px', color: 'var(--text-muted)' }}
                      placeholder="EAN (opcjonalnie)"
                    />
                  </td>
                  <td style={{ padding: '0.35rem', borderBottom: '1px solid var(--bg)', verticalAlign: 'top' }}>
                    <input
                      type="number"
                      value={product.ilosc}
                      onChange={(e) => updateProduct(index, 'ilosc', e.target.value)}
                      style={{ ...inputStyle, padding: '0.3rem 0.35rem', textAlign: 'center', fontSize: '12px', minWidth: '60px' }}
                      min="1" step="1"
                    />
                  </td>
                  <td style={{ padding: '0.35rem', borderBottom: '1px solid var(--bg)', verticalAlign: 'top' }}>
                    <select
                      value={product.jednostka || 'szt'}
                      onChange={(e) => updateProduct(index, 'jednostka', e.target.value)}
                      style={{ ...inputStyle, padding: '0.3rem 0.25rem', fontSize: '11px', minWidth: '55px' }}
                    >
                      {(units.length > 0 ? units : defaultUnits).map(unit => {
                        const code = unit.skrot || unit.symbol || 'szt';
                        return <option key={unit.id || code} value={code}>{code}</option>;
                      })}
                    </select>
                  </td>
                  <td style={{ padding: '0.35rem', borderBottom: '1px solid var(--bg)', verticalAlign: 'top' }}>
                    <input
                      type="number"
                      value={product.cena_netto}
                      onChange={(e) => updateProduct(index, 'cena_netto', e.target.value)}
                      style={{ ...inputStyle, padding: '0.25rem 0.35rem', textAlign: 'right' }}
                      step="0.01"
                    />
                  </td>
                  <td style={{ padding: '0.35rem', borderBottom: '1px solid var(--bg)', verticalAlign: 'top' }}>
                    <select
                      value={product.vat}
                      onChange={(e) => updateProduct(index, 'vat', e.target.value)}
                      style={{ ...inputStyle, padding: '0.3rem 0.25rem', fontSize: '11px', minWidth: '50px' }}
                    >
                      <option value="23">23%</option>
                      <option value="8">8%</option>
                      <option value="5">5%</option>
                      <option value="0">0%</option>
                      <option value="-1">zw.</option>
                    </select>
                  </td>
                  <td style={{ padding: '0.35rem', borderBottom: '1px solid var(--bg)', verticalAlign: 'top' }}>
                    <input
                      type="number"
                      value={product.cena_brutto}
                      onChange={(e) => updateProduct(index, 'cena_brutto', e.target.value)}
                      style={{ ...inputStyle, padding: '0.25rem 0.35rem', textAlign: 'right' }}
                      step="0.01"
                    />
                  </td>
                  <td style={{ padding: '0.35rem', borderBottom: '1px solid var(--bg)', textAlign: 'right', fontWeight: '600' }}>
                    {((parseFloat(product.cena_brutto) || 0) * (parseFloat(product.ilosc) || 0)).toFixed(2)} zl
                  </td>
                  <td style={{ padding: '0.35rem', borderBottom: '1px solid var(--bg)', textAlign: 'center' }}>
                    <button
                      onClick={() => removeProduct(index)}
                      style={{ background: 'none',  color: 'var(--danger)', cursor: 'pointer', fontSize: '12px' }}
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ backgroundColor: 'var(--border)' }}>
                <td colSpan="7" style={{ padding: '0.5rem', textAlign: 'right', fontWeight: '600' }}>RAZEM:</td>
                <td style={{ padding: '0.5rem', textAlign: 'right', fontWeight: '700', fontSize: '13px' }}>
                  {calculateTotal()} zl
                </td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        )}
      </div>
    </div>
  );
};

export default ProductsTable;
